module.exports = __webpack_public_path__ + "img/flavor_lemon.6cbf9e2f.png";